import { Text, type TextProps } from "@clipboard-health/ui-components";
import { type SxProps } from "@mui/material";

import { getTimeUntilDeactivationDisplayText } from "./utils/displayTextUtils";

const DYNAMIC_TEXT_DEADLINE_TO_CHART = "{{deadlineToChart}}";

interface ChartingNoncomplianceTextProps {
  text: string;
  deadlineToChart: string;
  sx?: SxProps;
  variant?: TextProps["variant"];
}

export function ChartingNoncomplianceText({
  text,
  deadlineToChart,
  sx,
  variant,
}: ChartingNoncomplianceTextProps) {
  const parts = text.split(new RegExp(`(${DYNAMIC_TEXT_DEADLINE_TO_CHART})`));
  const deadlineText = getTimeUntilDeactivationDisplayText(deadlineToChart);

  if (parts.length === 1) {
    return (
      <Text sx={sx} variant={variant}>
        {text}
      </Text>
    );
  }

  return (
    <Text sx={{ ...sx }}>
      {parts.map((part) =>
        part === DYNAMIC_TEXT_DEADLINE_TO_CHART ? (
          <Text
            key={part}
            variant={variant}
            sx={{ display: "inline", ...sx, paddingX: 0 }}
            color={(theme) => theme.palette.error.main}
          >
            {deadlineText}
          </Text>
        ) : (
          <Text key={part} variant={variant} sx={{ display: "inline", ...sx, paddingX: 0 }}>
            {part}
          </Text>
        )
      )}
    </Text>
  );
}
